import React, { useState } from "react";
import { Trash, WarningCircle } from "@phosphor-icons/react";
import DragDrop from "../../DragDrop";

const FloorMapInput = ({ value, onChange, error }) => {
    const handleFloorPlanUpload = (uploadedFiles) => {
        const newFiles = [...value, ...uploadedFiles];
        onChange(newFiles); // Pass the updated list of files to the parent component
    };

    return (
        <div className="h-[200px] border-b-[1.5px] py-3">
            <div className="flex h-full ">
                {/* Left half: Upload area */}
                <div className="w-full ">
                    <h2>Hotel Floor Plans</h2>
                    <DragDrop
                        onFilesUploaded={handleFloorPlanUpload}
                        acceptedFileTypes={{
                            "image/*": [".jpeg", ".png", ".jpg"],
                        }}
                        maxFiles={5}
                        dragDropText="Drag and drop floor plan images here"
                    />
                    {error && (
                        <span className="text-[#E47186] text-xs flex items-center gap-1">
                            <WarningCircle className="text-sm" />
                            {error}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FloorMapInput;
